import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import store from "@/store";
import routes from "./mybox";
Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "hash",
});
//主页面的导航icon高亮
const MainNavigationNavIndex = (to, from) => {
  let routerName = ["MrBoxHome", "Activity", "Market", "MineFirst", "MyInfo"]; //路由名字（一定要按照顺序）
  if (routerName.indexOf(to.name) != -1) {
    Vue.ls.set("navIndex", routerName.indexOf(to.name));
  }
};
//Mines能源场的子导航icon高亮
const MinesNavigationMineIndex = (to, from) => {
  let Mines = ["Mines", "NftGoods", "Games"];
  if (Mines.indexOf(to.name) != -1) {
    Vue.ls.set("MineIndex", Mines.indexOf(to.name));
  }
};
//主页bxo的子导航icon高亮
const BoxNavigationMineIndex = (to, from) => {
  let Mines = ["UnBoxs", "MakeBoxs", "Repository"];
  console.log(to.name, from.name);
  if (Mines.indexOf(to.name) != -1) {
    Vue.ls.set("BoxRouterIndex", Mines.indexOf(to.name));
    Vue.ls.set("navIndex",0)
  }
};
// Repository 导航icon高亮
const RepositoryNavigationMineIndex = (to, from) => {
  let Mines = ["Apple", "Rolex", "Nike", "Gucci", "Chanel", "LV"];
  console.log(to.name, from.name);
  if (Mines.indexOf(to.name) != -1) {
    Vue.ls.set("BoxRouterIndex", 2);
    Vue.ls.set("RepositoryRouterIdx", Mines.indexOf(to.name));
  }
};
router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    console.log("路由不存在");
    // 如果路由不存在，重定向到404页面
    next({ path: "*" });
  }
  if (!Vue.ls.get("IP")) {
    store.dispatch("SetIPDetail");
  }
  next();
});
router.afterEach((to, from) => {
  MinesNavigationMineIndex(to, from);
  MainNavigationNavIndex(to, from);
  BoxNavigationMineIndex(to, from);
  RepositoryNavigationMineIndex(to, from);
  // 在路由切换后执行逻辑
  // 可以进行页面切换的后续操作
});
//主导航的icon高亮

export default router;
